/* unplugin-vue-components disabled */import { render } from "./BottomTip.vue?vue&type=template&id=09e593f9&scoped=true&ts=true"
import script from "./BottomTip.vue?vue&type=script&lang=ts"
export * from "./BottomTip.vue?vue&type=script&lang=ts"

import "./BottomTip.vue?vue&type=style&index=0&id=09e593f9&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e593f9"]])

export default __exports__